// Legacy browser detection and device-link helpers
// Keep compatible with older browsers.

import Bowser from 'bowser';

export function detectLegacyBrowser(userAgent) {
    var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '') || '';
    var parser = null;
    try { parser = Bowser.getParser(ua); } catch (e) {}
    var isLegacy = false;
    if (parser && parser.satisfies) {
        var satisfiesLegacy = parser.satisfies({
            chrome: '<90',
            firefox: '<90',
            safari: '<13',
            opera: '<70',
            blackberry: '>0',
            'blackberry webkit': '>0'
        });
        isLegacy = !!satisfiesLegacy;
    }
    var uaLower = ua.toLowerCase();
    var isBB = uaLower.indexOf('bb10') !== -1 || uaLower.indexOf('blackberry') !== -1 || uaLower.indexOf('bbq') !== -1 || uaLower.indexOf('playbook') !== -1;
    var lacksModernApis = (typeof Promise === 'undefined') || (typeof fetch === 'undefined') || (typeof Symbol === 'undefined') || !(typeof window !== 'undefined' && window.crypto && window.crypto.subtle);
    if (isBB || lacksModernApis) {
        isLegacy = true;
    }
    return isLegacy;
}

export function startLegacyLoginFlow(api, qrcodeLib, onStarted, onLinked) {
    fetch(api('/api/device/start'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(function(res) { return res.json(); })
        .then(function(data) {
            if (!data || !data.code || !data.login_url) {
                throw new Error('Missing code');
            }
            var qr = qrcodeLib(0, 'L');
            qr.addData(data.login_url);
            qr.make();
            var qrDataUrl = '';
            try {
                qrDataUrl = qr.createDataURL ? qr.createDataURL(4) : '';
            } catch (e) {
                qrDataUrl = '';
            }
            if (onStarted) {
                onStarted({
                    code: data.code,
                    loginUrl: data.login_url,
                    qrDataUrl: qrDataUrl
                });
            }
            beginLegacyPoll(api, data.code, onLinked);
        })
        .catch(function() {
            alert('Failed to start legacy login.');
        });
}

var legacyTimer = null;

function beginLegacyPoll(api, code, onLinked) {
    if (legacyTimer) {
        clearInterval(legacyTimer);
    }
    legacyTimer = setInterval(function() {
        fetch(api('/api/device/status?code=' + encodeURIComponent(code)))
            .then(function(res) { return res.json(); })
            .then(function(data) {
                if (data && data.status === 'linked' && data.session_token) {
                    if (legacyTimer) {
                        clearInterval(legacyTimer);
                        legacyTimer = null;
                    }
                    try { localStorage.setItem('bb_session', data.session_token); } catch (e) {}
                    if (onLinked) onLinked();
                }
            })
            .catch(function() {});
    }, 2000);
}
